import { Events } from 'src/constants/webSocketConsts/events';
import {
  BuilderSession,
  builderSessionApi,
} from 'src/services/api/builderSessionApi';
import { AppDispatch } from 'src/store/configureStore';

const isBuilderSession = (item: unknown): item is BuilderSession =>
  typeof item === 'object' &&
  item !== null &&
  typeof (item as { id?: unknown }).id === 'string' &&
  typeof (item as { appBuilderId?: unknown }).appBuilderId === 'string';

export function handleBuilderSessionUpdate(
  event: Events,
  items: unknown[],
  dispatch: AppDispatch,
) {
  if (event !== Events.Insert && event !== Events.Modify) {
    return;
  }

  const sessions = items.filter(isBuilderSession);
  if (sessions.length === 0) {
    return;
  }

  // The lock indicator and composer disable both key off activeTurnId on the
  // session record. Update the cached session so subscribers re-render with
  // the new lock state without a refetch.
  for (const session of sessions) {
    dispatch(
      builderSessionApi.util.updateQueryData(
        'getBuilderSession',
        { appBuilderId: session.appBuilderId, sessionId: session.id },
        (draft: BuilderSession) => {
          Object.assign(draft, session);
        },
      ),
    );
  }
}
